import { computed, ref, watch } from 'vue'
import Misc from 'src/utils/helper/misc'
import { useStore } from 'vuex';
import { MdTypography } from '@antiqua-dls/vue-components'

export default {
    name: 'TextField',
    components: {
        MdTypography
    },
    props: {
        modelValue: {
            type: [String, Number],
            default: ''
        },
        acceptType: {
            type: String,
            default: '.png'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: 'name',
            required: true
        },
        validateOnMount: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: 'id',
            required: true
        },
        dataTestId: {
            type: String,
            default: 'test-id'
        },
        dataQaId: {
            type: String,
            default: 'data-qa-id'
        },
        placeholder: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        inputClass: {
            type: Array,
            default: () => []
        },
        errorClass: {
            type: [String, Object, Array],
            default: () => []
        },
        type: {
            type: String,
            default: 'text'
        },
        blur: {
            type: Function,
            default: () => { }
        },
        keyUp: {
            type: Function,
            default: () => { }
        },
        focus: {
            type: Function,
            default: () => { }
        },
        mouseOver: {
            type: Function,
            default: () => { }
        },
        mouseOut: {
            type: Function,
            default: () => { }
        },
        handleEnterKeyDown: {
            type: Function,
            default: () => { }
        },
        handleEnterKeyUp: {
            type: Function,
            default: () => { }
        },
        maxLength: Infinity,
        rules: {
            type: String,
            default: ''
        },
        showErrorMessage: {
            type: Boolean,
            default: true
        },
        showBannedWordErrorMessage: {
            type: Boolean,
            default: true
        },
        showWarningWordErrorMessage: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        refId: {
            type: String,
            default: 'ref'
        },
        emitBlur: {
            type: Boolean,
            default: false
        },
        errorIs: {
            type: Boolean,
            default: false
        },
        moduleName: {
            type: String,
            default: ''
        },
        foundryId: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
        runDetectBannedWords: {
            type: Boolean,
            default: false
        },
        showCounter: {
            type: Boolean,
            default: false
        },
        optionalText: {
            type: String,
            default: ''
        },
    },

    emits: ['change', 'blur', 'update:modelValue', 'update-description', 'update-banned-word', 'update-warning-existence', 'update-warning-words', 'update-detect'],
    setup(props, { emit }) {
        const handleChange = event => {
            emit('change', event)
        }

        const handleBlur = event => {
            detectBannedWord('text-field')
            if (props.blur) {
                props.blur(event)
            }
            return emit('blur', event)
        }

        const computedModelValue = computed({
            get() {
                return props.modelValue
            },
            set(value) {
                emit('update:modelValue', value)
            }
        })

        const store = useStore();
        const bannedWordIsPresent = ref(false)
        const warningWordIsPresent = ref(false)
        const warningWords = ref([])
        const previousWarningWords = ref([]);
        const previousBannedWords = ref([]);

        let detectBannedWordCounter = 0;
        const maxDetectBannedWordCalls = 4;

        const detectBannedWord = (fieldName) => {
            const bannedWordInfo = Misc.strikeThroughBadWords(props.description, store, fieldName, props.moduleName, props.foundryId, previousWarningWords.value, previousBannedWords.value)
            bannedWordIsPresent.value = bannedWordInfo.bannedWordExist
            warningWordIsPresent.value = bannedWordInfo.warningWordExist
            warningWords.value = bannedWordInfo.warningWordMatches;
            previousWarningWords.value = bannedWordInfo.warningWordMatches;
            previousBannedWords.value = bannedWordInfo.banned;
            emit('update-description', bannedWordInfo.description)
            emit('update-banned-word', bannedWordInfo.bannedWordExist)
            emit('update-warning-existence', bannedWordInfo.warningWordExist)
            emit('update-warning-words', bannedWordInfo.warningWordMatches)
            detectBannedWordCounter++;
            if (detectBannedWordCounter <= maxDetectBannedWordCalls) {
                emit('update-detect', false);
                detectBannedWordCounter = 0;
            }
        }
        watch(() => props.runDetectBannedWords, (newValue) => {
            if (newValue) {
                detectBannedWord('text-field')
            }
        });
        return {
            handleChange,
            handleBlur,
            computedModelValue,
            bannedWordIsPresent,
            warningWordIsPresent,
            warningWords
        }
    }
}